<div class="col-12 center">
	<mat-spinner *ngIf="loading"></mat-spinner>
</div>

<form class="example-form" *ngIf="!loading">
	<div class="row">
		<div class="col">
			<div class="row">
				<div class="col-md-12 fix-select">
          <div class="col">
            <a class="material-icons float-right custom-margin" (click)="removeSelf()"> clear </a>
          </div>
					<mat-form-field *ngIf="!modalFlag">
						<mat-label class="mat-label">Empresa Matriz</mat-label>
						<mat-select
							[(ngModel)]="selectedMasterCompany"
							(selectionChange)="selectMasterCompany()"
							name="selectedMasterCompany"
							#matSelect
						>
							<mat-option *ngFor="let company of companies" [value]="company">
								{{ company.companyName }}
							</mat-option>
						</mat-select>
					</mat-form-field>
					<div *ngIf="modalFlag" class="floating-labels">
						<select
							[(ngModel)]="selectedMasterCompany"
							name="selectedMasterCompany"
							id="masterCompany"
							class="custom-select form-control"
							(change)="selectMasterCompany()"
						>
							<option *ngFor="let company of companies" [ngValue]="company">
								{{ company.companyName }}
							</option>
						</select>
						<span class="bar"></span>
						<label for="masterCompany" class="floating-label">Empresa Matriz</label>
					</div>
				</div>
			</div>
			<div class="row my-5" *ngIf="selectedMasterCompany">
				<div class="col-6 col-md-4">
					<span class="title">Filial</span>
					<app-check-box
						(selectEvt)="selectSubdisiaries($event)"
						[subAreasOptions]="subdisiariesOptions"
						checkBoxAll="true"
						attrLabel="companyName"
						[enableScroll]="true"
					></app-check-box>
				</div>

				<div class="col-6 col-md-4">
					<span class="title">Departamento</span>
					<app-check-box
						(selectEvt)="selectDepartaments($event)"
						[subAreasOptions]="departamentsOptions"
						checkBoxAll="true"
						attrLabel="name"
						[enableScroll]="true"
					></app-check-box>
				</div>

				<div class="col-6 col-md-4">
					<span class="title">Cargo</span>
					<app-check-box
						(selectEvt)="selectRoles($event)"
						[subAreasOptions]="rolesOptions"
						checkBoxAll="true"
						attrLabel="name"
						[enableScroll]="true"
					></app-check-box>
				</div>
			</div>
			<div class="row my-2" *ngIf="selectedMasterCompany">
				<div class="col-6 col-md-4" *ngIf="localidadeOptions.length > 0">
					<span class="title">Localidade</span>
					<app-check-box
						(selectEvt)="selectLocalidade($event)"
						[subAreasOptions]="localidadeOptions"
						checkBoxAll="true"
						attrLabel="name"
						[enableScroll]="true"
					></app-check-box>
				</div>

				<div class="col-6 col-md-4" *ngIf="planoSaudeOptions.length > 0">
					<span class="title">Operadora de Saúde</span>
					<app-check-box
						(selectEvt)="selectPlanosSaude($event)"
						[subAreasOptions]="planoSaudeOptions"
						checkBoxAll="true"
						attrLabel="name"
						[enableScroll]="true"
					></app-check-box>
				</div>
			</div>
			<div class="row mb-4" *ngIf="selectedMasterCompany">
				<div class="col-md-6">
					<span class="title-ask">Disponível para dependentes?</span>
					<label class="custom-checkbox padding-checkbox">
						<input
              class="me-1"
							type="checkbox"
							[checked]="classification.availableForDependents"
							(change)="handleChangeAvailableForDependents($event)"
						/>
						<span>Sim</span>
					</label>
				</div>
				<div class="col-md-6">
					<span class="title-ask">Disponível para menores de 18 anos?</span>
					<label class="custom-checkbox padding-checkbox">
						<input
              class="me-1"
							type="checkbox"
							[checked]="classification.availableForMinors"
							(change)="handleChangeAvailableForMinors($event)"
						/>
						<span>Sim</span>
					</label>
				</div>
			</div>
			<span class="users" *ngIf="selectedMasterCompany">Usuários específicos</span>
			<div class="row mt-3" *ngIf="selectedMasterCompany">
				<ng-template #resultUsers let-r="result" let-t="term">
					<ngb-highlight [result]="r.nameEmail" [term]="t"></ngb-highlight>
				</ng-template>
				<div class="col-md-12 form-group">
					<input
						type="text"
						id="userIn"
						name="userIn"
						class="form-control hover"
						[(ngModel)]="userIn"
						#userInInput="ngModel"
						maxlength="80"
						[ngbTypeahead]="usersPipe"
						[resultTemplate]="resultUsers"
						[inputFormatter]="formatter"
						(selectItem)="selectOneUser($event)"
						placeholder="Digite um nome de usuário"
					/>
					<span class="bar"></span>
					<div class="row my-2" *ngIf="classification?.users?.length > 0">
						<div class="col">
							<div class="d-flex flex-wrap">
								<div
									class="m-2 p-2 border-users-selected"
									*ngFor="let u of classification.users"
								>
									<a class="font-size-12 material-icons hover" (click)="removedSelectUser(u)"> close </a>
									<span class="font-size-14 mx-1"> {{ u.name }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row" *ngIf="flagTestFailure">
				<div class="col">Selecione pelo menos uma opção acima.</div>
			</div>
		</div>
	</div>
</form>
